import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { House, UsersThree, GraduationCap, UserCircle, Briefcase } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/dashboard", label: "Home", icon: House, match: ["/dashboard"] },
  { to: "/network", label: "Network", icon: UsersThree, match: ["/network", "/connections", "/directory", "/find"] },
  { to: "/jobs", label: "Jobs", icon: Briefcase, match: ["/jobs"] },
  { to: "/institutions", label: "Institutions", icon: GraduationCap, match: ["/institutions"] },
  { to: "/profile", label: "Profile", icon: UserCircle, match: ["/profile"] },
];

// App-style bottom navigation for signed-in users on mobile. Hidden on >=sm.
export default function MobileTabBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    if (user) document.body.classList.add("has-tabbar");
    else document.body.classList.remove("has-tabbar");
    return () => document.body.classList.remove("has-tabbar");
  }, [user]);

  if (!user) return null;

  return (
    <nav
      data-testid="mobile-tabbar"
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-5 border-t border-border/60 bg-white/95 backdrop-blur sm:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {TABS.map((t) => {
        const active = t.match.some((m) => pathname === m || pathname.startsWith(m + "/"));
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            data-testid={`tab-${t.label.toLowerCase()}`}
            className={`flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium transition-colors ${active ? "text-primary" : "text-muted-foreground"}`}
          >
            <Icon size={22} weight={active ? "fill" : "regular"} />
            {t.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
